import { render } from "./Settings.vue?vue&type=template&id=283fd048"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/bambl/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__